// TICKET-01256: a visitor email stored with an invisible trailing space made
// Tripletex reject the customer as invalid, but the form showed no warning —
// the field's checkValue validation only ran while typing, never for values
// already in the database.
//
// Fields flagged with `checkValueOnLoad: true` in lib/fields.js get their
// checkValue run against the freshly loaded object, so stored invalid values
// surface the same warning as when typing. The flag is opt-in because some
// checkValue implementations are expensive (e.g. productNumber does an API
// lookup) and must not fire on every form load.
export function runOnLoadFieldChecks({ sections, object, holdingStore }) {
    if (!object || !object.id || !Array.isArray(sections) || !holdingStore) {
        return;
    }
    sections.forEach(section => {
        (section.fields || []).forEach(field => {
            if (field.checkValueOnLoad && typeof field.checkValue === 'function') {
                field.checkValue(object, holdingStore);
            }
        });
    });
}

export default runOnLoadFieldChecks;
